import { render, staticRenderFns } from "./forgot.vue?vue&type=template&id=7be72b0a&scoped=true"
import script from "./forgot.vue?vue&type=script&lang=js"
export * from "./forgot.vue?vue&type=script&lang=js"
import style0 from "./forgot.vue?vue&type=style&index=0&id=7be72b0a&prod&lang=scss"
import style1 from "./forgot.vue?vue&type=style&index=1&id=7be72b0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be72b0a",
  null
  
)

export default component.exports